import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import VideosCard from "../../components/video-card/index";
import { useAppSelector } from "../../store/hooks";
import { getSearchResults } from "../../store/reducers/search.reducer";
import { RootState } from "../../store";
import { SearchElement } from "../../types/search";
import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, InputLabel, MenuItem, Select, useTheme } from "@mui/material";
import ChannelCard from "../../components/channel-profile-card/ChannelCard";
import { getChannelVideos } from "../../services/APIServices/channel.api";
import { ShortVideosCard } from "../Shorts/Shorts";
import { PAGE_ROUTES } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import logoOnly from "../../assets/IndeeFlix-logo-only.png";
import { isMobile } from "react-device-detect";
import { FilterList } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

// export default function SearchPage() {
//   const data = useAppSelector((state: RootState) => getSearchResults(state));

//   const videos = data?.filter((ele: any) => ele.type === "Video").map((ele: any) => ele.video) || [];
//   const channels = data?.filter((ele: any) => ele.type === "Channel") || [];

//   return (
//     <Container
//       sx={{
//         justifyContent: "center",
//         alignItems: "center",
//       }}
//     >
//       <Typography style={{ margin: "15px 0px 10px 0px" }}>
//         Search Results...
//       </Typography>
//       <Divider style={{ margin: "15px 0px 10px 0px", visibility: "inherit" }} />

//       {data?.length ? (
//         <>
//           {videos?.length > 0 && GetElementByType("Video", videos)}
//           {channels?.map((ele: any) => GetElementByType("Channel", ele))}
//         </>
//       ) : (
//         <Typography variant={"h6"}>No Results Found!</Typography>
//       )}
//     </Container>
//   );
// }

// const GetElementByType = (type: string, details: any) => {
//   const [channelVideos, setChannelVideos] = useState([]);

//   useEffect(() => {
//     if (type === "Channel" && details?.channel?.channelID) {
//       getChannelVideos(details.channel.channelID).then((res: any) => {
//         if (res) setChannelVideos(res);
//       });
//     }
//   }, [type, details]);

//   const getElement = () => {
//     switch (type) {
//       case "Video":
//         return <VideosCard sx={{ width: "100%" }} data={details} />;

//       case "Channel":
//         return (
//           <Container>
//             <ChannelCard data={details.channel} fullWidth />
//             <VideosCard sx={{ width: "100%" }} data={channelVideos} />
//           </Container>
//         );

//       default:
//         return <Typography variant={"h6"}>No Result Found!</Typography>;
//     }
//   };

//   return type && details ? (
//     getElement()
//   ) : (
//     <Typography variant={"h6"}>No Result Found!</Typography>
//   );
// };

export default function SearchPage() {
  const data = useAppSelector((state: RootState) => getSearchResults(state));
  const navigate = useNavigate();
  const theme = useTheme();
  const { t } = useTranslation();
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const [tempFilter, setTempFilter] = useState({
    videotype: "",
    duration: "",
    uploadTime: "",
  });

  const videos = data?.filter((ele: any) => ele.type === "Video").map((ele: any) => ele.video) || [];
  // const channels = data?.filter((ele: any) => ele.type === "Channel") || [];
  // const shortVideos = videos?.filter((ele: any) => ele.videoType === "short") || [];

  const applyFilters = () => {
    const params = new URLSearchParams(window.location.search);

    // Set new filters
    if (tempFilter.videotype) params.set("videotype", tempFilter.videotype);
    else params.delete("videotype");

    if (tempFilter.duration) params.set("duration", tempFilter.duration);
    else params.delete("duration");

    if (tempFilter.uploadTime) params.set("uploadTime", tempFilter.uploadTime);
    else params.delete("uploadTime");

    // Navigate to updated URL
    navigate(`${PAGE_ROUTES.SEARCH_PAGE}?${params.toString()}`);

    // Scroll to top
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Re-trigger handleSearch manually using dispatch event
    window.dispatchEvent(new CustomEvent("searchWithURL"));

    setShowFilterPopup(false);
  };

  return (
    <Container
      sx={{
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          my: 2,
        }}
      >
        <Typography style={{ margin: "15px 0px 10px 0px" }}>
          {t("searchPage.searchResults")}
        </Typography>
        <Button
          onClick={() => {
            setShowFilterPopup(true);
          }}
        >
          <FilterList />
          {t("searchPage.filter")}
        </Button>


      </Box>
      <Dialog
        open={showFilterPopup}
        onClose={() => setShowFilterPopup(false)}
        PaperProps={{
          sx: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            borderRadius: 3,
            minWidth: isMobile ? "100%" : 400,
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold", fontSize: 18 }}>{t("searchPage.filter")}</DialogTitle>

        <DialogContent dividers>
          <Box mb={3}>
            <FormControl fullWidth>
              <InputLabel sx={{ color: theme.palette.text.secondary }}>{t("searchPage.videoType")}</InputLabel>
              <Select
                value={tempFilter.videotype}
                onChange={(e) =>
                  setTempFilter((prev) => ({ ...prev, videotype: e.target.value }))
                }
                sx={{
                  color: theme.palette.text.primary,
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.divider,
                  },
                }}
              >
                <MenuItem value="">{t("searchPage.none")}</MenuItem>
                <MenuItem value="full">{t("searchPage.full")}</MenuItem>
                <MenuItem value="short">{t("searchPage.short")}</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box mb={3}>
            <FormControl fullWidth>
              <InputLabel sx={{ color: theme.palette.text.secondary }}>{t("searchPage.duration")}</InputLabel>
              <Select
                value={tempFilter.duration}
                onChange={(e) =>
                  setTempFilter((prev) => ({ ...prev, duration: e.target.value }))
                }
                sx={{
                  color: theme.palette.text.primary,
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.divider,
                  },
                }}
              >
                <MenuItem value="">{t("searchPage.none")}</MenuItem>
                {["0-4", "5-15", "15-30", "30-60", "60-120"].map((range) => (
                  <MenuItem key={range} value={range}>
                    {range} min
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box mb={3}>
            <FormControl fullWidth>
              <InputLabel sx={{ color: theme.palette.text.secondary }}>{t("searchPage.uploadTime")}</InputLabel>
              <Select
                value={tempFilter.uploadTime}
                onChange={(e) =>
                  setTempFilter((prev) => ({ ...prev, uploadTime: e.target.value }))
                }
                sx={{
                  color: theme.palette.text.primary,
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.divider,
                  },
                }}
              >
                <MenuItem value="">{t("searchPage.none")}</MenuItem>
                <MenuItem value="this_week">{t("searchPage.thisWeek")}</MenuItem>
                <MenuItem value="this_month">{t("searchPage.thisMonth")}</MenuItem>
                <MenuItem value="last_6_months">{t("searchPage.last6Months")}</MenuItem>
                <MenuItem value="this_year">{t("searchPage.thisYear")}</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>


        <DialogActions sx={{ justifyContent: "space-between", px: 3 }}>
          <Button
            onClick={() => {
              setTempFilter({ videotype: "", duration: "", uploadTime: "" });
              const params = new URLSearchParams(window.location.search);
              params.delete("videotype");
              params.delete("duration");
              params.delete("uploadTime");
              navigate(`${PAGE_ROUTES.SEARCH_PAGE}?${params.toString()}`);
              window.dispatchEvent(new CustomEvent("searchWithURL"));
              setShowFilterPopup(false);
            }}
            color="error"
          >
            {t("searchPage.clearAll")}
          </Button>


          <Box display="flex" gap={1}>
            <Button onClick={() => setShowFilterPopup(false)} variant="outlined">
              {t("cancel")}
            </Button>
            <Button
              variant="contained"
              onClick={applyFilters}
            >
              {t("searchPage.apply")}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <Divider style={{ margin: "15px 0px 10px 0px", visibility: "inherit" }} />

      {data?.length ? (
        groupVideosByType(data).map((group: any, index: number) => {
          if (group.type === "Channel" && group.channel) {
            return (
              <ElementByType
                key={`channel-${index}`}
                type="Channel"
                details={group}
              />
            );
          }

          if (group.type === "short") {
            return (
              <ElementByType
                key={`shorts-${index}`}
                type="ShortVideo"
                details={group.videos}
              />
            );
          }

          if (group.type === "full") {
            return (
              <ElementByType
                key={`full-${index}`}
                type="Video"
                details={group.videos}
              />
            );
          }

          return null;
        })
      ) : (
        <Typography variant="h6">{t("searchPage.noResult")}</Typography>
      )}
    </Container>
  );
}

const ElementByType: React.FC<{ type: string; details: any }> = ({ type, details }) => {
  const [channelVideos, setChannelVideos] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (type === "Channel" && details?.channel?.channelID) {
      getChannelVideos(details.channel.channelID).then((res: any) => {
        if (res) setChannelVideos(res);
      });
    }
  }, [type, details]);

  if (!type || !details) {
    return <Typography variant={"h6"}>{t("searchPage.noResult")}</Typography>;
  }

  switch (type) {
    case "ShortVideo":
      return <>
        <Box sx={{ mt: 2, p: 2, bgcolor: "background.paper", borderRadius: 2 }}>
          {/* <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <img src={logoOnly} alt="Theme Logo" width={30} height={30} style={{ marginRight: 8 }} />
            <Typography variant="h6" fontWeight="bold">
              {t("clips")}
            </Typography>
          </Box> */}
          <ShortVideosCard isLoading={false} data={details} onVideoClick={(videoId: string, channelID?: string) =>
            navigate(`${PAGE_ROUTES.SHORT_VIDEO_PAGE}/${videoId}`)
          } /></Box></>;

    case "Video":
      const fullVideos = details.filter((video: any) => video.videoType !== "short");
      return <VideosCard sx={{ width: "100%" }} data={fullVideos} />;

    case "Channel":
      // const shortVideos = channelVideos.filter((video: any) => video.videoType === "short");

      // const fullChannelVideos = channelVideos.filter((video: any) => video.videoType !== "short");

      return (
        <Container>
          <ChannelCard data={details.channel} fullWidth />

          {/* Show Short Videos if available */}
          {/* {shortVideos.length > 0 && (
            <Box sx={{ mt: 2, p: 2, bgcolor: "background.paper", borderRadius: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <img src={logoOnly} alt="Theme Logo" width={30} height={30} style={{ marginRight: 8 }} />
                <Typography variant="h6" fontWeight="bold">{t("clips")}</Typography>
              </Box>
              <ShortVideosCard
                isLoading={false}
                data={shortVideos}
                onVideoClick={(videoId: string) =>
                  navigate(`${PAGE_ROUTES.SHORT_VIDEO_PAGE}/${videoId}`)
                }
              />
            </Box>
          )} */}

          {/* Show Full Videos if available */}
          {/* {fullChannelVideos.length > 0 && (
            <VideosCard sx={{ width: "100%" }} data={fullChannelVideos} />
          )} */}
        </Container>
      );

    default:
      return <Typography variant="h6">{t("searchPage.noResult")}</Typography>;
  }
};

// Helper: group consecutive videos of same type
const groupVideosByType = (items: any[]) => {
  const grouped: any[] = [];
  let currentGroup: any = null;

  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    // Directly push channels (they break grouping)
    if (item.type === "Channel") {
      if (currentGroup) {
        grouped.push(currentGroup);
        currentGroup = null;
      }
      grouped.push(item);
      continue;
    }

    // For videos
    const videoType = item.video.videoType;

    if (!currentGroup) {
      currentGroup = { type: videoType, videos: [item.video] };
    } else if (currentGroup.type === videoType) {
      currentGroup.videos.push(item.video);
    } else {
      grouped.push(currentGroup);
      currentGroup = { type: videoType, videos: [item.video] };
    }
  }

  if (currentGroup) grouped.push(currentGroup);
  return grouped;
};
